import { post } from "./utils";

export const setAccount = async (accountId: string, isExternal: boolean) =>
  await post("accounts", { accountId, isExternal });
